import { useEffect, useState } from "preact/hooks";
import type { InstallRunner } from "../flow/runner";
import { t } from "../i18n";
import { FALLBACK_MODELS, type SupportedModel } from "../models/supported";
import { BrowserCheckPanel, currentBrowserCheck } from "./BrowserCheck";
import { ModelsTable } from "./ModelsTable";

export function SignInStep({ runner, models }: { runner: InstallRunner; models: readonly SupportedModel[] }) {
  const [token, setToken] = useState("");
  const [busy, setBusy] = useState(false);
  const check = currentBrowserCheck();
  const submit = async (e: Event) => {
    e.preventDefault();
    setBusy(true);
    await runner.signIn(token);
    setBusy(false);
  };
  return (
    <>
      <div class="panel">
        <h2 tabIndex={-1}>{t("signin.heading")}</h2>
        <p>{t("signin.intro")}</p>
        <form onSubmit={(e) => void submit(e)} class="stack">
          <div>
            <label for="dev-token">{t("signin.dev_token_label")}</label>
            <input id="dev-token" class="ltr" type="password" autocomplete="off" value={token} onInput={(e) => setToken((e.target as HTMLInputElement).value)} required aria-describedby="dev-token-hint" />
            <p id="dev-token-hint" class="hint">{t("signin.dev_token_hint")}</p>
          </div>
          <div class="row">
            <button type="submit" class="primary" disabled={busy || !token}>{busy ? t("signin.signing_in") : t("signin.button")}</button>
          </div>
        </form>
      </div>
      <div class="panel">
        <ModelsTable models={models.length ? models : FALLBACK_MODELS} />
      </div>
      <div class="panel">
        <BrowserCheckPanel check={check} />
      </div>
    </>
  );
}

export function useModels(runner: InstallRunner): readonly SupportedModel[] {
  const [models, set] = useState<readonly SupportedModel[]>(FALLBACK_MODELS);
  useEffect(() => {
    void runner["d"].api.models().then((r) => set(r.models)).catch(() => undefined);
  }, [runner]);
  return models;
}
